import { Navigate } from "react-router-dom";

import { changeLanguageWithTenant } from "multitenancy/i18n";

import { useAppSelector } from "store/rootReducer";

type Props = {
  children: JSX.Element;
};

export function AuthStateGuard({ children }: Props) {
  const { user } = useAppSelector((state) => state.user);
  const { accessToken } = useAppSelector((state) => state.auth);

  const isUserInStorage = () => {
    try {
      if (user && accessToken) {
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error checking user storage:", error);
      return false;
    }
  };

  if (!isUserInStorage()) {
    try {
      const savedLng = localStorage.getItem("userLanguage");
      localStorage.clear();

      if (savedLng) {
        localStorage.setItem("userLanguage", savedLng);
        changeLanguageWithTenant(savedLng);
      }
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }

    return <Navigate to="/" />;
  }

  return children;
}
